import React from 'react';
import SEO from '../components/SEO';
import ServiceLayout from '../components/ServiceLayout';

const TrainingPage: React.FC = () => {
  return (
    <>
      <SEO
        title="Equipment Training & Staff Education"
        description="Hands-on training for clinical and support staff on proper use, safety, and best practices for installed healthcare equipment."
        keywords="healthcare equipment training, hospital staff education, clinical equipment training, medical device training, post-installation training"
        url="https://www.jvphealthtechsolutions.com/services/training"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "Service",
          "name": "Healthcare Equipment Training & Staff Education",
          "description": "Hands-on training for clinical and support staff on proper use, safety, and best practices for installed healthcare equipment.",
          "provider": { "@type": "Organization", "name": "JVP Health Tech Solutions" },
          "areaServed": "US"
        }}
      />
      <ServiceLayout
        title="Training & Education"
        subtitle="Hands-on training so your team gets the most from every piece of equipment we install."
        pageImage="/images/services/training-d988adc1.jpg"
        pageImageAlt="Staff training on hospital equipment"
        ctaText="Schedule Training"
        summary="Equipment is only as good as the people using it. We train your clinical and support staff on proper operation, safety, and best practices — so they're confident from day one."
        sections={[
          {
            title: 'What We Cover',
            body: 'Training is tailored to your team\'s roles and the specific equipment installed in your facility.',
            items: [
              'Proper operation of articulating arms, monitor mounts, and height-adjustable workstations',
              'Safe positioning and ergonomic adjustment for different clinical workflows',
              'Mobile workstation battery management, charging, and cart handling',
              'Basic troubleshooting and when to escalate to maintenance',
              'Infection control best practices for equipment surfaces and touchpoints',
              'Department-specific workflows — nursing, lab, pharmacy, OR',
            ],
          },
          {
            title: 'Training Formats',
            body: 'We meet your team where they are — whether that\'s during install week or months later for a refresher.',
            items: [
              'On-site hands-on sessions during or immediately after installation',
              'Department-specific training tailored to your team\'s workflows',
              'Train-the-trainer programs for ongoing staff onboarding',
              'Follow-up sessions to address questions and reinforce best practices',
            ],
          },
        ]}
      />
    </>
  );
};

export default TrainingPage;
